import React from 'react';
import { isNull } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

import { AnswerData } from 'types/answer';

interface Props {
  answer: AnswerData;
}

export default ({ answer }: Props) => {
  if (!answer.hasInputs) {
    if (answer.prompt.type === 'Question Passage') {
      return (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`question-passage-tooltip-${answer.id}`}>
              This was a question passage.
            </Tooltip>
          }
        >
          <span><FontAwesomeIcon icon="file-text" /></span>
        </OverlayTrigger>
      );
    } else if (answer.prompt.type === 'Video Clip') {
      return (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`video-clip-tooltip-${answer.id}`}>
              This was a video clip.
            </Tooltip>
          }
        >
          <span><FontAwesomeIcon icon="video-camera" /></span>
        </OverlayTrigger>
      );
    } else if (answer.prompt.type === 'Audio Clip') {
      return (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`audio-clip-tooltip-${answer.id}`}>
              This was an audio clip.
            </Tooltip>
          }
        >
          <span><FontAwesomeIcon icon="volume-up" /></span>
        </OverlayTrigger>
      );
    }
  }

  if (answer.examSection.allowsGradingRequestGrading) {
    if (!isNull(answer.gradingRequestGradeValue)) {
      return (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`grading-request-grade-tooltip-${answer.id}`}>
              {
                (!isNull(answer.prompt.gradeMax) && !isNull(answer.prompt.gradeMin)) ? (
                  `Scores range from ${answer.prompt.gradeMin} to ${answer.prompt.gradeMax}`
                ) : 'You answer was graded by AI'
              }
            </Tooltip>
          }
        >
          <strong
            style={{
              background: 'linear-gradient(90deg, #2A6EB6, #5239C0)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            {answer.gradingRequestGradeValue}
          </strong>
        </OverlayTrigger>
      );
    } else if (answer.scoreReport && ['error', 'finished'].indexOf(answer.scoreReport.status) === -1) {
      return (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`grading-processing-tooltip-${answer.id}`}>
              Your answer is being graded.
            </Tooltip>
          }
        >
          <span><FontAwesomeIcon className="fa-spin" icon="refresh" style={{ color: '#2A6EB6' }} /></span>
        </OverlayTrigger>
      );
    } else {
      return (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`grading-incomplete-tooltip-${answer.id}`}>
              Your answer was not graded.
            </Tooltip>
          }
        >
          <span><FontAwesomeIcon icon="question-circle" /></span>
        </OverlayTrigger>
      );
    }
  }

  if (answer.examSection.allowsSelfGrading) {
    if (isNull(answer.selfGradeValue)) {
      return (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`self-grade-needed-tooltip-${answer.id}`}>
              Click on this answer to read our rubrics and grade yourself
            </Tooltip>
          }
        >
          <span><FontAwesomeIcon icon="question-circle" /></span>
        </OverlayTrigger>
      );
    } else {
      return (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`self-grading-grade-tooltip-${answer.id}`}>
              {
                (!isNull(answer.prompt.gradeMax) && !isNull(answer.prompt.gradeMin)) ? (
                  `Scores range from ${answer.prompt.gradeMin} to ${answer.prompt.gradeMax}`
                ) : 'You self-graded this answer.'
              }
            </Tooltip>
          }
        >
          <strong
            style={{
              background: 'linear-gradient(90deg, #2A6EB6, #5239C0)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            {answer.selfGradeValue}
          </strong>
        </OverlayTrigger>
      );
    }
  }

  if (answer.isGraded) {
    if (answer.isCorrect) {
      return (
        <span><FontAwesomeIcon className="text-primary" icon="check-circle" /></span>
      );
    } else {
      return (
        <span><FontAwesomeIcon className="text-danger" icon="times-circle" /></span>
      );
    }
  }

  return <FontAwesomeIcon icon="question-circle" />;
};
